module.exports = __webpack_public_path__ + "static/media/culturaunam_v2.b777ca9a.png";